<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3> {{ label.get('manual_entries') }}</h3>
      </div>
      <div class="white-card manual-entries">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('preference') }}</label>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="field-wrap d-flex justify-content-between align-items-center">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="manualEntriesToggle"
                  @change="toggleManualEntries"
              >
                {{ label.get('manual_entries') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('manual_entries_description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card manual-entries-roles" v-if="manualEntriesToggle">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('roles') }}</label>
          </div>
        </div>
        <div
            class="subsection no-border roles settings content-wrapper"
            :class="{disabled: !manualEntriesToggle}"
        >
          <div class="check-wrapper">
            <b-form-checkbox
                v-model="companySettings.manage_entries_admin"
                :disabled="!manualEntriesToggle"
                @change="toggleRoleChange()"
            >
              {{ label.get('admins') }}
            </b-form-checkbox>
          </div>
          <div class="check-wrapper">
            <b-form-checkbox
                v-model="companySettings.manage_entries_manager"
                :disabled="!manualEntriesToggle"
                @change="toggleRoleChange()"
            >
              {{ label.get('managers') }}
            </b-form-checkbox>
          </div>
          <div class="check-wrapper">
            <b-form-checkbox
                v-model="companySettings.manage_entries_employee"
                :disabled="!manualEntriesToggle"
                @change="toggleRoleChange()"
            >
              {{ label.get('employees') }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
    import ManualEntriesService from './services/ManualEntriesService';
    export default {
        name: "ManualEntriesComponent",
        data() {
            return {
                companySettings: this.$store.state.companySettings,
                manualEntriesToggle: this.$store.state.companySettings.allow_manual_entries,
                debounce: null
            }
        },
        mounted() {
            console.log(this.companySettings);
        },
        methods: {
            toggleManualEntries() {
                const _this = this;
                this.$store.state.companySettings.allow_manual_entries = !_this.manualEntriesToggle;
                if(_this.debounce){
                    clearTimeout(_this.debounce);
                }

                _this.debounce = setTimeout(() => {
                    ManualEntriesService.updateCompanySettings(_this.$store.state.companySettings).then((result) => {
                      debugger
                      this.$awn.success(result.data.message);
                    }).catch(() => {})
                }, 1000);
            },

            toggleRoleChange(){
                const _this = this;

                if(_this.debounce){
                    clearTimeout(_this.debounce);
                }

                _this.debounce = setTimeout(() => {
                    ManualEntriesService.updateCompanySettings(_this.companySettings).then((result) => {
                      _this.$store.state.companySettings = _this.companySettings;
                      this.$awn.success(result.data.message);
                    }).catch((error) => {
                        console.log(error);
                    })
                }, 1000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .subsection {
      position: relative;
        &.top-border {
            border-top: 2px solid $atto-light-grey;
            border-bottom: 0;
            padding-bottom: 0;
        }

        &.roles {
            :last-child {
                margin-bottom: 0;
            }
        }

      &.disabled{
        &::after{
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 10;
        }
      }
    }

    .toggle-dep{
        margin: 0;
    }
</style>
<style lang="scss">
  .manual-entries-roles .check-wrapper .custom-checkbox .custom-control-label::before,
  .manual-entries-roles .check-wrapper .custom-checkbox .custom-control-label::after{
    border-radius: 0 !important;
  }
  .manual-entries .switch-wrapper.check-wrapper .custom-checkbox .custom-control-label,
  .manual-entries-roles .check-wrapper .custom-checkbox .custom-control-label{
    font-weight: $roboto-regular;
  }
  .manual-entries p.disclaimer{
    color: #666666;
    width: 520px;
    margin-top: 4px;
  }
  .check-wrapper .custom-checkbox .custom-control-label{
    padding-left: 16px;
  }
</style>